import { render, staticRenderFns } from "./InventoryCdkPushGoneAction.vue?vue&type=template&id=61c3aa58"
import script from "./InventoryCdkPushGoneAction.vue?vue&type=script&lang=js"
export * from "./InventoryCdkPushGoneAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports